import { ComponentsOverrides, ComponentsProps, Theme } from "@mui/material";
import Fade from "@mui/material/Fade";

import borders from "@/themes/base/borders";
import colors from "@/themes/base/colors";
import typography from "@/themes/base/typography";
import pxToRem from "@/themes/functions/pxToRem";

const { black, light } = colors;
const { size, fontWeightRegular } = typography;
const { borderRadius } = borders;

interface ITooltip {
  defaultProps: ComponentsProps["MuiTooltip"];
  styleOverrides: ComponentsOverrides<Theme>["MuiTooltip"];
}

const tooltip: ITooltip = {
  defaultProps: {
    arrow: true,
    TransitionComponent: Fade,
  },

  styleOverrides: {
    tooltip: {
      maxWidth: pxToRem(200),
      backgroundColor: black.main,
      color: light.main,
      fontSize: size.sm,
      fontWeight: fontWeightRegular,
      textAlign: "center",
      borderRadius: borderRadius.md,
      opacity: 0.7,
      padding: `${pxToRem(5)} ${pxToRem(8)} ${pxToRem(4)}`,
    },

    arrow: {
      color: black.main,
    },
  },
};

export default tooltip;
